import React, { useState } from 'react';
import WebsiteNavbar from '../../components/WebsiteUI/WebsiteNavbar';
import WebsiteFooter from '../../components/WebsiteUI/WebsiteFooter';
import CTASection from '../../components/WebsiteUI/CTASection';
import FAQ from '../../components/WebsiteUI/FAQ';
import { pricingPlans, comparisonFeatures, comparisonColumns, faqItems } from '../../data/pricing';
import PricingCard from './PricingCard';
import ComparisonTable from './ComparisonTable';
import EnterpriseCard from './EnterpriseCard';
import styles from './PricingPage.module.css';

const PricingPage = () => {
  const [isYearly, setIsYearly] = useState(false);

  return (
    <>
      <WebsiteNavbar />
      <div className={styles.pricing}>
        <div className={styles.pricing__hero}>
          <div className={styles.pricing__container}>
            <div className={styles.pricing__header}>
              <h1 className={styles.pricing__title}>Find the pricing plan that works for you</h1>
            </div>
            <div className={styles['pricing-toggle']}>
              <div className={styles['pricing-toggle__wrapper']}>
                <div className={`${styles['pricing-toggle__bg']} ${isYearly ? styles['pricing-toggle__bg--right'] : ''}`}></div>
                <button
                  type="button"
                  className={`${styles['pricing-toggle__button']} ${!isYearly ? styles['pricing-toggle__button--active'] : ''}`}
                  onClick={() => setIsYearly(false)}
                >
                  Monthly
                </button>
                <button
                  type="button"
                  className={`${styles['pricing-toggle__button']} ${isYearly ? styles['pricing-toggle__button--active'] : ''}`}
                  onClick={() => setIsYearly(true)}
                >
                  Yearly <span className={styles['pricing-toggle__discount']}>(10% off)</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.pricing__cards}>
          <div className={styles.pricing__container}>
            <div className={styles.pricing__grid}>
              {pricingPlans.map((plan) => (
                <PricingCard key={plan.name} plan={plan} isYearly={isYearly} />
              ))}
            </div>
          </div>
        </div>

        <div className={styles.pricing__enterprise}>
          <div className={styles.pricing__container}>
            <EnterpriseCard />
          </div>
        </div>

        <div className={styles.pricing__comparison}>
          <div className={styles.pricing__container}>
            <h2 className={styles.pricing__sectionTitle}>Compare plans</h2>
            <ComparisonTable features={comparisonFeatures} columns={comparisonColumns} />
          </div>
        </div>

        <div className={styles.pricing__faq}>
          <div className={styles.pricing__container}>
            <FAQ
              title="Frequently asked questions"
              description="Everything you need to know about the product and billing."
              items={faqItems}
            />
          </div>
        </div>
      </div>
      <CTASection />
      <WebsiteFooter />
    </>
  );
};

export default PricingPage;
